import React from 'react'
import { Form, Field, reduxForm } from 'redux-form'
import SelectPretty from 'components/Input/SelectPretty'
import { vRequired } from 'components/Input/Input.validations'
import cn from 'classnames'
import Button from 'components/Button'
import sLay from 'styles/modules/layout.scss'
import sText from 'components/Text/Text.scss'
import { useGetPhoneSystemNumbersQuery } from 'src/generated/graphql'

const IncomingCallPhoneSystemFormComponent = props => {
  const { handleSubmit, className, onSubmit, node, nodeInfo, flow } = props
  const submit = data => onSubmit(node, { extras: data })
  const getPhoneSystemNumbersQuery = useGetPhoneSystemNumbersQuery({
    variables: {
      phoneSystemId: flow.phoneSystemId,
    },
  })

  const options =
    getPhoneSystemNumbersQuery.data?.phoneSystemNumbers.map(item => ({
      name: `${item.number} ${item.customerReference}`,
      value: item.id,
    })) || []

  return (
    <Form onSubmit={handleSubmit(submit)} className={className}>
      <div style={{ paddingBottom: '15px' }} className={sText.descrip3}>
        This node will trigger whenever the selected number is called. Note, each number can only be
        attached to one flow.{' '}
        <a href={nodeInfo.helpUrl} target="_blank" rel="noopener noreferrer">
          {' '}
          Learn more.
        </a>
      </div>
      <Field
        name="numberSid"
        options={options}
        component={SelectPretty}
        label="Number"
        validate={[vRequired]}
      />
      <div className={sLay.flex} />
      <div className={cn(sLay['layout-column'])}>
        <Button type="submit" color="tertiary" rect>
          Save Node
        </Button>
      </div>
    </Form>
  )
}

export const IncomingCallPhoneSystemForm = reduxForm({
  destroyOnUnmount: true,
})(IncomingCallPhoneSystemFormComponent)



// WEBPACK FOOTER //
// src/features/Flows/Flow/Nodes/IncomingCall/IncomingCallPhoneSystemForm.tsx